export function getdata() {
	let obj = {
		headdata: [
			{
				name: '选择票据'
			},
			{
				name: '信息确认'
			},
			{
				name: '提交成功'
			}
		]
	}
	return obj
}
